import { Filter } from "model/filtering";

export const TRANSACTIONS_NS = "TRANSACTIONS";

export interface TransactionsState {
  filters: Filter[];
  searchTerm: string;
}
